import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GROUP_BY_UUID_RESOURCE } from "../group/use-group-by-uuid.query";
import { USER_APP_ROLE_RESOURCE } from "../user/use-user-app-role.query";

export const RULE_UPDATE_RESOURCE = "rule" as const;
export const RULE_UPDATE_API_PATH = `/v1/${RULE_UPDATE_RESOURCE}/{uuid}` as const;

export type RuleUpdateBody = paths[typeof RULE_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type RuleUpdateResponse =
  paths[typeof RULE_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useRuleUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<RuleUpdateResponse, Error, RuleUpdateBody & { uuid: string }>({
    mutationFn: async (rule: RuleUpdateBody & { uuid: string }) => {
      const { uuid, ...rest } = rule;
      const response = await alphartisApiAxios.patch<RuleUpdateResponse>(`/v1/${RULE_UPDATE_RESOURCE}/${uuid}`, rest);
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [RULE_UPDATE_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [GROUP_BY_UUID_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [USER_APP_ROLE_RESOURCE],
        }),
      ]);
    },
  });
};
